var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29244 6.71041C6.19993 6.61771 6.09004 6.54416 5.96907 6.49398C5.8481 6.4438 5.71841 6.41797 5.58744 6.41797C5.45648 6.41797 5.32679 6.4438 5.20582 6.49398C5.08485 6.54416 4.97496 6.61771 4.88244 6.71041L0.292444 11.3004C0.199741 11.3929 0.126193 11.5028 0.0760117 11.6238C0.0258302 11.7448 0 11.8744 0 12.0054C0 12.1364 0.0258302 12.2661 0.0760117 12.387C0.126193 12.508 0.199741 12.6179 0.292444 12.7104L4.88244 17.3004C4.97503 17.393 5.08494 17.4664 5.2059 17.5165C5.32687 17.5666 5.45651 17.5924 5.58744 17.5924C5.71837 17.5924 5.84802 17.5666 5.96899 17.5165C6.08995 17.4664 6.19986 17.393 6.29244 17.3004C6.38503 17.2078 6.45847 17.0979 6.50857 16.977C6.55868 16.856 6.58447 16.7263 6.58447 16.5954C6.58447 16.4645 6.55868 16.3348 6.50857 16.2139C6.45847 16.0929 6.38503 15.983 6.29244 15.8904L2.41244 12.0004L6.29244 8.12041C6.67244 7.73041 6.67244 7.09041 6.29244 6.71041Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.71751c0f68d9ae607a97ecb58c6d9b81.svg";
export { ForwardRef as ReactComponent };